export default {
  urls: {
    profile: '/p/',
    ticket: '/ticket/',
    auth: null,
    achievements: '/loyalty/achievements/',
    travelexpert: '/loyalty/travelexpert/',
  },

  STATUSES: {
    classic: 'classic',
    premium: 'premium',
    pro: 'pro',
    guest: 'guest',
    exclusive: 'exclusive',
  },

  POSITION: {
    free: 'free',
    inplace: 'inplace',
  },

  MENU_ITEMS: {
    login: 'login',
    exit: 'exit',
    order: 'order',
    profile: 'profile',
    profileLogin: 'profileLogin',
    mobileLogin: 'mobileLogin',
    achievements: 'achievements',
    virtualcard: 'virtualcard',
    travelexpert: 'travelexpert',
    supportLink: 'supportLink',
    orderOtt: 'orderOtt',
  },

  MAX_NAME_LENGTH: 14,
};
